
(function () {
  'use strict';

  // Voorkom dat het script dubbel wordt gestart.
  if (window.__sgCartTimerInitialised) return;
  window.__sgCartTimerInitialised = true;

  var DURATION = 5 * 60 * 1000;
  var STORAGE_KEY = 'sg_cart_timer_end_v1';
  var intervalId = null;

  function readEndTime() {
    try {
      var value = Number(sessionStorage.getItem(STORAGE_KEY));
      return Number.isFinite(value) && value > 0 ? value : 0;
    } catch (error) {
      return 0;
    }
  }

  function saveEndTime(value) {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (error) {}
  }

  function getDrawer() {
    return document.querySelector('[data-slaapgemak-cart-drawer]');
  }

  function getBody() {
    var drawer = getDrawer();
    return drawer
      ? drawer.querySelector('[data-slaapgemak-cart-body]')
      : null;
  }

  function getTimer() {
    var body = getBody();
    return body ? body.querySelector('[data-sg-cart-timer]') : null;
  }

  function ensureTimer() {
    var body = getBody();
    if (!body) return null;

    var items = body.querySelector('.slaapgemak-cart-drawer__items');
    if (!items) return null;

    var timer = body.querySelector('[data-sg-cart-timer]');

    if (!timer) {
      timer = document.createElement('div');
      timer.className = 'slaapgemak-cart-timer';
      timer.setAttribute('data-sg-cart-timer', '');

      timer.innerHTML =
        '<div class="slaapgemak-cart-timer__icon" aria-hidden="true">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none">' +
            '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/>' +
            '<path d="M12 7V12L15.5 14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</div>' +
        '<div class="slaapgemak-cart-timer__content">' +
          '<p class="slaapgemak-cart-timer__text">' +
            'Wegens drukte houden we je artikelen maar beperkte tijd voor je vast.' +
          '</p>' +
          '<div class="slaapgemak-cart-timer__countdown" data-sg-cart-timer-countdown role="timer" aria-label="Resterende tijd">05:00</div>' +
          '<div class="slaapgemak-cart-timer__track" aria-hidden="true">' +
            '<div class="slaapgemak-cart-timer__progress" data-sg-cart-timer-progress></div>' +
          '</div>' +
        '</div>';
    }

    // Plaats de timer direct boven de verzendbalk.
    var shipping = body.querySelector('[data-sg-shipping]');
    var target = shipping || items;

    if (timer.parentNode !== body || timer.nextElementSibling !== target) {
      body.insertBefore(timer, target);
    }

    return timer;
  }

  function formatTime(milliseconds) {
    var seconds = Math.max(0, Math.ceil(milliseconds / 1000));
    var minutes = Math.floor(seconds / 60);
    var remainder = seconds % 60;

    return String(minutes).padStart(2, '0') + ':' +
      String(remainder).padStart(2, '0');
  }

  function renderTimer() {
    var endTime = readEndTime();
    var timer = getTimer();

    if (!endTime || !timer) return;

    var remaining = Math.max(0, endTime - Date.now());
    var countdown = timer.querySelector('[data-sg-cart-timer-countdown]');
    var progress = timer.querySelector('[data-sg-cart-timer-progress]');

    if (countdown) {
      countdown.textContent = formatTime(remaining);
    }

    if (progress) {
      progress.style.width =
        Math.max(0, Math.min(100, remaining / DURATION * 100)) + '%';
    }

    timer.classList.toggle('is-expired', remaining <= 0);

    if (remaining <= 0 && intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  }

  function updateDisplay() {
    ensureTimer();
    renderTimer();
  }

  function startInterval() {
    if (intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }

    updateDisplay();

    if (readEndTime() > Date.now()) {
      intervalId = window.setInterval(renderTimer, 1000);
    }
  }

  function resetTimer() {
    saveEndTime(Date.now() + DURATION);
    startInterval();
  }

  function resumeTimer() {
    if (readEndTime() > Date.now()) {
      startInterval();
    } else {
      updateDisplay();
    }
  }

  function isAddToCartUrl(url) {
    if (!url) return false;

    try {
      var parsed = new URL(url, window.location.origin);
      return /\/cart\/add(?:\.js)?\/?$/.test(parsed.pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url));
    }
  }

  // Ondersteuning voor Shopify-thema's die fetch gebruiken voor AJAX.
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var requestUrl = args[0] instanceof Request
        ? args[0].url
        : String(args[0]);

      var isAddRequest = isAddToCartUrl(requestUrl);
      var result = originalFetch.apply(this, args);

      if (!isAddRequest) return result;

      return result.then(function (response) {
        if (response.ok) {
          resetTimer();

          // Geef de winkelwagen-JavaScript even de tijd om de
          // nieuwe inhoud te renderen voordat we de timer plaatsen.
          window.setTimeout(updateDisplay, 100);
          window.setTimeout(updateDisplay, 350);
        }

        return response;
      });
    };
  }

  // Ondersteuning voor thema's die XMLHttpRequest gebruiken.
  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__sgCartAddRequest = isAddToCartUrl(url);
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__sgCartAddRequest) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            resetTimer();
            window.setTimeout(updateDisplay, 100);
            window.setTimeout(updateDisplay, 350);
          }
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function initialise() {
    // Herstel een lopende timer bij het laden van iedere pagina.
    resumeTimer();

    // Ondersteuning voor gewone productformulieren.
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (
        form &&
        form.matches &&
        form.matches('form[action*="/cart/add"]')
      ) {
        resetTimer();
      }
    }, true);

    // De winkelwagen is bijgewerkt: alleen de weergave verversen.
    document.addEventListener('slaapgemak:cart-updated', updateDisplay);
    document.addEventListener('slaapgemak:cart-drawer-opened', function () {
      updateDisplay();
      resumeTimer();
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-slaapgemak-cart-open]')) {
        updateDisplay();
        resumeTimer();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
